import { IoMdAdd } from "react-icons/io";
import { useRef } from 'react';

// NEW ITEM SET NEW ITEM HANDLE SUBMIT POPPED DRILED FROM APP.JS
const AddItem = ({ newItem, setNewItem, handleSubmit }) => {
    const inputRef = useRef();

    return (
        <form className='addForm' onSubmit={handleSubmit}>
            <label htmlFor='addItem'></label>
            <input
                autoFocus
                ref={inputRef}
                id='addItem'
                type='text'
                placeholder='Add Notes '
                required
                value={newItem}
                onChange={(e) => setNewItem(e.target.value)}
            />
            <button
                type='submit'
                aria-label='Add Item'
                onClick={() => inputRef.current.focus()}
            >
            <IoMdAdd />
            </button>
        </form>
    )
}

export default AddItem